<template>
  <div class="empty-gift-question">
    <div class="show-b">
    </div>
    <div class="question">
      <div class="checkbox">
        <button @click="send('')" v-if="value===index" class="icon done">
          <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 1L4.45847 6.54153L1 3.07305" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
          </svg>
        </button>
        <button @click="send('')" v-else class="icon cancel">
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1L1 6.99999" stroke="#06364B" stroke-miterlimit="10"/>
            <path d="M1 1L7 6.99999" stroke="#06364B" stroke-miterlimit="10"/>
          </svg>
        </button>
      </div>
      <button>
        {{question.title}}
      </button>
    </div>
    <div class="answer">
      {{question.description}}
    </div>
  </div>
</template>
<script>

  export default {
    props:{
    value: {},
    question:{},
    index: {}
    },
    components:{

    },
    data() {
      return {
        flag: false,
        checkbox: false,
      }
    },
    methods:{
      send(){

        if(this.value !== this.index) {
          this.$emit('input', this.index);
        } else {
          this.$emit('input', '');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
//
  .empty-gift-question{
    position: relative;
    margin: 2px 0;

    transition: all .4s ease-in-out;
    color: #828282;
    .question{
      display: flex;
      align-items: center;
      padding: 15px 5px 15px 22px;
      font-family: Heebo;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      text-align: right;
      color: #FFFFFF ;
      .checkbox{
        left: 12px;
        position: absolute;
        .icon{
          width: 20px;
          height: 20px;
          border-radius: 15px;
          border: 1px solid #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .done{
          background: #8CC63F;
        }
        .cancel{

        }
      }
      button{
        padding: 0;
        border: none;
        font: inherit;
        color: inherit;
        background-color: transparent;
        width: 88%;
        text-align: start;
        @media screen and (max-width: 600px){
          font-size: 15px;
        }
      }
    }
    .show-b{
      position: absolute;
      right: 22px;
      top: 11px;
      span{
        svg{
          transition-property: all;
          transition-duration: 0.3s;
          transition-timing-function: ease-in-out;
        }
      }
    }
    .answer{
      font-family: Heebo;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 23px;
      text-align: right;
      width: 90%;
      color: #FFFFFF;
      transition: all 0.4s ease-in-out;
    }
  }

  .slide-fade-enter-active {
    transition: all .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active до версии 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
</style>

